import { render } from "./FirebaseMessage.vue?vue&type=template&id=3ac14c0e&lang=pug"
import script from "./FirebaseMessage.vue?vue&type=script&lang=js"
export * from "./FirebaseMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__